// extracted by mini-css-extract-plugin
module.exports = {"AppCardContainer":"_3JIX96S2uVeT9vVhz0W45q","CardImage":"_2KrqrDwtD5B4bv0sCBEzo_","CardDescription":"_2it8CJvR8ErROY4F0BeLiz","CardTitle":"_3yFjmAMsXCOIHvmFXelIpu"};